/* Glow reviews: Loox-style review wall.
   Reviews come from assets/glow-reviews-<handle>.json (imported, built by glow-reviews/import.mjs)
   plus approved customer reviews from the reviews server (data-api). New reviews are held for approval. */
(function () {
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.5l2.6 5.5 6 .7-4.5 4.1 1.2 5.9L10 14.8l-5.3 2.9 1.2-5.9L1.4 7.7l6-.7z"/></svg>';
  var CHECK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.5l2.5 2.5L10 3.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MAX_FILES = 6, MAX_VIDEOS = 2, MAX_IMAGE_MB = 25, MAX_VIDEO_MB = 100;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function stars(rating, size) {
    var s = el('span', 'gr-stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', rating + ' out of 5 stars');
    if (size) s.style.setProperty('--s', size + 'px');
    var off = '', i;
    for (i = 0; i < 5; i++) off += STAR.replace('<svg', '<svg class="off"');
    s.innerHTML = off + '<span class="on" style="width:' + Math.max(0, Math.min(100, rating * 20)) + '%">' + STAR + STAR + STAR + STAR + STAR + '</span>';
    return s;
  }
  function fmtDate(iso) {
    var p = (iso || '').split('-');
    return p.length === 3 ? +p[2] + ' ' + MONTHS[+p[1] - 1] + ' ' + p[0] : '';
  }
  function ukDate(iso) {
    var p = (iso || '').split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : '';
  }
  var FILTER_ICO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16l-6 7.5V19l-4-2v-4.5z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';
  var SORT_ICO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4v15M8 4L4.5 7.5M8 4l3.5 3.5M16 20V5M16 20l-3.5-3.5M16 20l3.5-3.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function who(r) {
    var w = el('div', 'gr-who');
    w.appendChild(el('span', '', r.n));
    if (r.s) w.appendChild(el('span', 'gr-tag gr-tag--src', 'via ' + r.s));
    else if (r.v) { var v = el('span', 'gr-tag'); v.innerHTML = CHECK; v.appendChild(document.createTextNode('Verified buyer')); w.appendChild(v); }
    return w;
  }
  function textBlock(r, parent) {
    if (r.t) parent.appendChild(el('p', 'gr-title', r.t));
    if (r.b) parent.appendChild(el('p', 'gr-text', r.b));
    if (r.rp) { var rp = el('div', 'gr-reply'); rp.appendChild(el('b', '', 'Glow Trail replied')); rp.appendChild(document.createTextNode(r.rp)); parent.appendChild(rp); }
  }

  function Wall(root) {
    this.root = root;
    this.base = root.dataset.base;
    this.api = (root.dataset.api || '').replace(/\/$/, '');
    this.handle = root.dataset.handle;
    this.perPage = +root.dataset.page || 12;
    this.maxCols = +root.dataset.cols || 3;
    this.product = root.dataset.product || '';
    this.isList = root.dataset.layout !== 'grid';
    if (this.isList) root.classList.add('gr--list');
    this.all = [];
    this.sort = 'relevant';
    this.star = 0;
    this.shown = this.perPage;
    this.cols = 0;
    this.bind();
    this.writerSetup();
    this.load(root.dataset.src);
  }
  Wall.prototype.q = function (sel) { return this.root.querySelector(sel); };

  // Media items: imported ones are theme assets {f, a}; customer uploads are {u, k, a, po}.
  Wall.prototype.isVideo = function (p) { return p.k === 'video'; };
  Wall.prototype.thumb = function (p) { return p.u ? (p.k === 'video' ? p.po || '' : p.u) : this.base + p.f + '-t.jpg'; };
  Wall.prototype.full = function (p) { return p.u ? p.u : this.base + p.f + '.jpg'; };

  Wall.prototype.load = function (src) {
    var self = this;
    var getJson = function (url) {
      return fetch(url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    };
    Promise.all([
      getJson(src),
      this.api && this.handle ? getJson(this.api + '/api/reviews?handle=' + encodeURIComponent(this.handle)) : null,
    ]).then(function (res) {
      var seen = {}, all = [];
      [res[1] && res[1].reviews, res[0] && res[0].reviews].forEach(function (list) {
        (list || []).forEach(function (r) { if (!seen[r.id]) { seen[r.id] = 1; all.push(r); } });
      });
      self.all = all;
      var dist = [0, 0, 0, 0, 0], sum = 0;
      all.forEach(function (r) { dist[r.r - 1]++; sum += r.r; });
      self.data = { count: all.length, avg: all.length ? Math.round((sum / all.length) * 10) / 10 : 0, dist: dist };
      self.renderHead();
      self.renderStrip();
      self.render();
    });
  };

  Wall.prototype.bind = function () {
    var self = this;
    this.q('[data-gr-sort]').addEventListener('change', function (e) { self.sort = e.target.value; self.shown = self.perPage; self.render(); });
    this.q('[data-gr-more]').addEventListener('click', function () { self.shown += self.perPage; self.render(true); });
    this.lightbox = this.q('[data-gr-lightbox]');
    this.writer = this.q('.gr-writer');
    this.q('[data-gr-write]').addEventListener('click', function () { self.openWriter(); });
    [this.lightbox, this.writer].forEach(function (d) {
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-gr-close]')) d.close();
      });
    });
    this.lightbox.addEventListener('close', function () { var v = self.lightbox.querySelector('video'); if (v) v.pause(); });
    this.q('[data-gr-prev]').addEventListener('click', function () { self.open(self.cur - 1, 0); });
    this.q('[data-gr-next]').addEventListener('click', function () { self.open(self.cur + 1, 0); });
    this.lightbox.addEventListener('keydown', function (e) {
      if (e.target.tagName === 'VIDEO') return;
      if (e.key === 'ArrowLeft') self.open(self.cur - 1, 0);
      if (e.key === 'ArrowRight') self.open(self.cur + 1, 0);
    });
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { if (self.data && !self.isList && self.colCount() !== self.cols) self.render(true); }).observe(this.q('[data-gr-grid]'));
    }
  };

  Wall.prototype.renderHead = function () {
    var d = this.data, self = this;
    if (!d.count) return;
    this.q('[data-gr-avg]').textContent = d.avg.toFixed(1);
    var avgStars = this.q('[data-gr-avg-stars]');
    avgStars.innerHTML = '';
    avgStars.appendChild(stars(d.avg, 18));
    this.q('[data-gr-count]').textContent = 'Based on ' + d.count + ' review' + (d.count === 1 ? '' : 's');
    this.q('[data-gr-score]').hidden = false;
    var hist = this.q('[data-gr-hist]');
    hist.innerHTML = '';
    for (var s = 5; s >= 1; s--) {
      var n = d.dist[s - 1] || 0;
      var b = el('button');
      b.type = 'button';
      b.dataset.star = s;
      b.disabled = !n;
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Show ' + s + '-star reviews (' + n + ')');
      b.appendChild(el('span', '', s + ' ★'));
      var bar = el('i'), fill = el('b');
      fill.style.width = (n / d.count) * 100 + '%';
      bar.appendChild(fill);
      b.appendChild(bar);
      b.appendChild(el('span', '', n));
      b.addEventListener('click', function () {
        var v = +this.dataset.star;
        self.star = self.star === v ? 0 : v;
        self.shown = self.perPage;
        self.render();
      });
      hist.appendChild(b);
    }
    hist.hidden = false;
    this.q('[data-gr-bar]').hidden = false;
    if (this.isList) this.renderTools();
  };

  // Judge.me-style filter and sort icon buttons with small menus.
  Wall.prototype.renderTools = function () {
    var self = this, write = this.q('[data-gr-write]');
    if (this.q('.grl-tools')) return;
    var tools = el('div', 'grl-tools');
    write.parentNode.insertBefore(tools, write);
    tools.appendChild(write);
    var menu = el('div', 'grl-menu');
    menu.hidden = true;
    var mkBtn = function (ico, label, build) {
      var b = el('button', 'grl-ico');
      b.type = 'button';
      b.innerHTML = ico;
      b.setAttribute('aria-label', label);
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var same = !menu.hidden && menu.dataset.kind === label;
        menu.hidden = same;
        if (same) return;
        menu.dataset.kind = label;
        menu.innerHTML = '';
        build().forEach(function (o) {
          var it = el('button', 'grl-opt' + (o.on ? ' is-on' : ''), o.t);
          it.type = 'button';
          it.disabled = !!o.off;
          it.addEventListener('click', function () { o.go(); menu.hidden = true; self.shown = self.perPage; self.render(); });
          menu.appendChild(it);
        });
      });
      tools.appendChild(b);
    };
    mkBtn(FILTER_ICO, 'Filter reviews', function () {
      var d = self.data.dist, opts = [{ t: 'All reviews', on: !self.star, go: function () { self.star = 0; } }];
      for (var s = 5; s >= 1; s--) (function (s) { opts.push({ t: s + ' star (' + (d[s - 1] || 0) + ')', on: self.star === s, off: !d[s - 1], go: function () { self.star = s; } }); })(s);
      return opts;
    });
    mkBtn(SORT_ICO, 'Sort reviews', function () {
      return [['relevant', 'Most relevant'], ['recent', 'Most recent'], ['high', 'Highest rating'], ['low', 'Lowest rating'], ['photos', 'With photos']].map(function (o) {
        return { t: o[1], on: self.sort === o[0], go: function () { self.sort = o[0]; } };
      });
    });
    tools.appendChild(menu);
    document.addEventListener('click', function (e) { if (!menu.contains(e.target)) menu.hidden = true; });
  };

  // One review as a Judge.me-style list row.
  Wall.prototype.listItem = function (r, idx) {
    var self = this, it = el('article', 'grl-item');
    it.appendChild(stars(r.r, 22));
    var w = el('div', 'grl-who');
    w.appendChild(el('span', 'grl-av', (r.n || '?').charAt(0).toUpperCase()));
    var meta = el('div');
    var nm = el('div', 'grl-name');
    nm.appendChild(el('b', '', r.n));
    if (r.v && !r.s) { var v = el('span', 'gr-tag'); v.innerHTML = CHECK; v.appendChild(document.createTextNode('Verified')); nm.appendChild(v); }
    if (r.s) nm.appendChild(el('span', 'gr-tag gr-tag--src', 'via ' + r.s));
    meta.appendChild(nm);
    meta.appendChild(el('div', 'grl-date', ukDate(r.d)));
    w.appendChild(meta);
    it.appendChild(w);
    textBlock(r, it);
    if (r.p && r.p.length) {
      var ph = el('div', 'grl-photos');
      r.p.forEach(function (p, pi) {
        var src = self.thumb(p);
        if (!src) return;
        var b = el('button', 'grl-ph');
        b.type = 'button';
        b.setAttribute('aria-label', (self.isVideo(p) ? 'Video' : 'Photo') + ' from ' + r.n);
        var im = el('img');
        im.src = src; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        if (self.isVideo(p)) { var pl = el('span', 'gr-play'); pl.innerHTML = PLAY; b.appendChild(pl); }
        b.addEventListener('click', function () { self.open(idx, pi); });
        ph.appendChild(b);
      });
      it.appendChild(ph);
    }
    return it;
  };

  Wall.prototype.renderStrip = function () {
    if (this.root.dataset.strip !== 'true') return;
    var strip = this.q('[data-gr-strip]'), self = this, count = 0;
    strip.innerHTML = '';
    this.all.forEach(function (r) {
      (r.p || []).forEach(function (p, pi) {
        var src = self.thumb(p);
        if (!src) return;
        var b = el('button');
        b.type = 'button';
        b.setAttribute('aria-label', (self.isVideo(p) ? 'Video' : 'Photo') + ' from ' + r.n + "'s review");
        var img = el('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        b.appendChild(img);
        if (self.isVideo(p)) { var pl = el('span', 'gr-play'); pl.innerHTML = PLAY; b.appendChild(pl); }
        b.addEventListener('click', function () {
          self.star = 0;
          self.render(true);
          self.open(self.list.indexOf(r), pi);
        });
        strip.appendChild(b);
        count++;
      });
    });
    strip.hidden = count < 2;
  };

  Wall.prototype.sorted = function () {
    var list = this.all.slice(), star = this.star;
    if (star) list = list.filter(function (r) { return r.r === star; });
    var byDate = function (a, b) { return b.d < a.d ? -1 : b.d > a.d ? 1 : 0; };
    var hasMedia = function (r) { return r.p && r.p.length ? 1 : 0; };
    switch (this.sort) {
      case 'recent': list.sort(byDate); break;
      case 'high': list.sort(function (a, b) { return b.r - a.r || byDate(a, b); }); break;
      case 'low': list.sort(function (a, b) { return a.r - b.r || byDate(a, b); }); break;
      case 'photos': list = list.filter(hasMedia).sort(byDate); break;
      default: // relevant: photos/videos first, then higher rated, longer and newer reviews
        list.sort(function (a, b) {
          return hasMedia(b) - hasMedia(a) || b.r - a.r || ((b.b || '').length > 60) - ((a.b || '').length > 60) || byDate(a, b);
        });
    }
    return list;
  };

  Wall.prototype.colCount = function () {
    var w = this.q('[data-gr-grid]').clientWidth || this.root.clientWidth;
    return Math.max(1, Math.min(this.maxCols, w < 560 ? 2 : w < 900 ? Math.min(3, this.maxCols) : this.maxCols));
  };

  Wall.prototype.card = function (r, idx) {
    var self = this;
    var c = el('div', 'gr-card');
    c.tabIndex = 0;
    c.setAttribute('role', 'button');
    c.setAttribute('aria-label', 'Open ' + r.n + "'s review");
    var first = r.p && r.p[0];
    if (first && this.thumb(first)) {
      var m = el('div', 'gr-card__media');
      var img = el('img');
      img.src = this.thumb(first);
      img.alt = (this.isVideo(first) ? 'Video' : 'Photo') + ' from ' + r.n;
      img.loading = 'lazy';
      img.width = 640;
      img.height = Math.round(640 * (first.a || 1));
      m.appendChild(img);
      if (this.isVideo(first)) { var pl = el('span', 'gr-play'); pl.innerHTML = PLAY; m.appendChild(pl); }
      if (r.p.length > 1) m.appendChild(el('span', 'gr-card__count', '1/' + r.p.length));
      c.appendChild(m);
    }
    var body = el('div', 'gr-card__body');
    body.appendChild(who(r));
    var line = el('div', 'gr-line');
    line.appendChild(stars(r.r, 15));
    line.appendChild(el('span', 'gr-date', fmtDate(r.d)));
    body.appendChild(line);
    textBlock(r, body);
    c.appendChild(body);
    c.addEventListener('click', function (e) { if (!e.target.closest('.gr-readmore')) self.open(idx, 0); });
    c.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === c) { e.preventDefault(); self.open(idx, 0); } });
    return c;
  };

  // Rough height so cards land in the shortest column (keeps reading order left to right).
  Wall.prototype.estimate = function (r, colW) {
    var h = 92 + (r.t ? 24 : 0) + Math.min(6, Math.ceil(((r.b || '').length * 7.4) / Math.max(120, colW - 32))) * 22;
    if (r.p && r.p.length) h += colW * (r.p[0].a || 1);
    return h;
  };

  Wall.prototype.render = function (keep) {
    var grid = this.q('[data-gr-grid]'), self = this;
    this.list = this.sorted();
    var visible = this.list.slice(0, this.shown);
    if (this.isList) {
      grid.innerHTML = '';
      grid.classList.add('grl-list');
      visible.forEach(function (r, idx) { grid.appendChild(self.listItem(r, idx)); });
    } else {
    this.cols = this.colCount();
    var colW = (grid.clientWidth - 16 * (this.cols - 1)) / this.cols;
    var cols = [], heights = [], i;
    grid.innerHTML = '';
    for (i = 0; i < this.cols; i++) { cols.push(el('div', 'gr-col')); heights.push(0); grid.appendChild(cols[i]); }
    visible.forEach(function (r, idx) {
      var k = heights.indexOf(Math.min.apply(null, heights));
      cols[k].appendChild(self.card(r, idx));
      heights[k] += self.estimate(r, colW) + 16;
    });
    }
    // Cut-off reviews get a Show more / Show less toggle.
    grid.querySelectorAll('.gr-card .gr-text, .grl-item .gr-text').forEach(function (t) {
      if (t.scrollHeight <= t.clientHeight + 2) return;
      var b = el('button', 'gr-readmore', 'Show more');
      b.type = 'button';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = t.classList.toggle('is-open');
        b.textContent = open ? 'Show less' : 'Show more';
        b.setAttribute('aria-expanded', String(open));
      });
      t.after(b);
    });
    this.q('[data-gr-more]').hidden = this.list.length <= this.shown;
    this.q('[data-gr-empty]').hidden = this.all.length > 0;
    var info = this.q('[data-gr-info]');
    info.textContent = this.star ? 'Showing ' + this.list.length + ' ' + this.star + '-star review' + (this.list.length === 1 ? '' : 's') : this.all.length + ' review' + (this.all.length === 1 ? '' : 's');
    if (this.star) {
      var clr = el('button', '', 'Show all');
      clr.type = 'button';
      clr.addEventListener('click', function () { self.star = 0; self.shown = self.perPage; self.render(); });
      info.appendChild(clr);
    }
    this.root.querySelectorAll('[data-gr-hist] button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.star === self.star)); });
    if (!keep && this.renderedOnce) this.q('[data-gr-bar]').scrollIntoView({ block: 'nearest' });
    this.renderedOnce = true;
  };

  Wall.prototype.open = function (idx, mediaIdx) {
    if (idx < 0 || idx >= this.list.length) return;
    var self = this, r = this.list[idx];
    this.cur = idx;
    var lb = this.q('[data-gr-lb]');
    lb.innerHTML = '';
    var items = (r.p || []).filter(function (p) { return self.full(p); });
    lb.className = 'gr-lb' + (items.length ? '' : ' gr-lb--text');
    if (items.length) {
      var media = el('div', 'gr-lb__media');
      var stage = el('div', 'gr-lb__stage');
      media.appendChild(stage);
      var dots = el('div', 'gr-lb__dots');
      var show = function (i) {
        mediaIdx = (i + items.length) % items.length;
        var p = items[mediaIdx], node;
        stage.innerHTML = '';
        if (self.isVideo(p)) {
          node = el('video');
          node.src = self.full(p);
          if (p.po) node.poster = p.po;
          node.controls = true;
          node.playsInline = true;
          node.preload = 'metadata';
          node.autoplay = true;
          node.muted = true;
        } else {
          node = el('img');
          node.src = self.full(p);
          node.alt = 'Photo from ' + r.n;
        }
        stage.appendChild(node);
        dots.querySelectorAll('button').forEach(function (d, k) { d.setAttribute('aria-current', String(k === mediaIdx)); });
      };
      if (items.length > 1) {
        items.forEach(function (_, k) {
          var d = el('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Item ' + (k + 1));
          d.addEventListener('click', function () { show(k); });
          dots.appendChild(d);
        });
        var pv = el('button', 'gr-lb__pv', '‹'), nx = el('button', 'gr-lb__nx', '›');
        pv.type = nx.type = 'button';
        pv.setAttribute('aria-label', 'Previous photo');
        nx.setAttribute('aria-label', 'Next photo');
        pv.addEventListener('click', function () { show(mediaIdx - 1); });
        nx.addEventListener('click', function () { show(mediaIdx + 1); });
        media.appendChild(pv);
        media.appendChild(nx);
        media.appendChild(dots);
      }
      lb.appendChild(media);
      show(Math.min(mediaIdx || 0, items.length - 1));
    }
    var body = el('div', 'gr-lb__body');
    body.appendChild(who(r));
    var line = el('div', 'gr-line');
    line.appendChild(stars(r.r, 17));
    line.appendChild(el('span', 'gr-date', fmtDate(r.d)));
    body.appendChild(line);
    textBlock(r, body);
    if (this.product) body.appendChild(el('p', 'gr-lb__product', 'Reviewed: ' + this.product));
    lb.appendChild(body);
    this.q('[data-gr-prev]').disabled = idx === 0;
    this.q('[data-gr-next]').disabled = idx === this.list.length - 1;
    if (!this.lightbox.open) this.lightbox.showModal();
  };

  /* ---------- Write a review (held for approval) ---------- */

  Wall.prototype.writerSetup = function () {
    var self = this;
    this.form = this.q('[data-gr-form]');
    this.files = [];
    if (!this.form) return;
    this.q('[data-gr-file]').addEventListener('change', function (e) {
      self.addFiles(Array.prototype.slice.call(e.target.files || []));
      e.target.value = '';
    });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    this.writer.addEventListener('close', function () {
      if (!self.q('[data-gr-thanks]').hidden) self.resetForm();
    });
  };

  Wall.prototype.openWriter = function () {
    this.openedAt = Date.now();
    this.loadUploader();
    this.writer.showModal();
  };

  Wall.prototype.loadUploader = function () {
    if (this.uploaderPromise) return this.uploaderPromise;
    var src = this.root.dataset.uploader;
    this.uploaderPromise = new Promise(function (resolve, reject) {
      if (window.GlowBlob) return resolve(window.GlowBlob);
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { resolve(window.GlowBlob); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return this.uploaderPromise;
  };

  Wall.prototype.error = function (msg) {
    var e = this.q('[data-gr-err]');
    e.textContent = msg || '';
    e.hidden = !msg;
  };

  Wall.prototype.addFiles = function (list) {
    var self = this;
    this.error('');
    list.forEach(function (f) {
      var video = /^video\//.test(f.type) || /\.(mp4|mov|webm|m4v)$/i.test(f.name);
      var image = /^image\//.test(f.type) || /\.(jpe?g|png|webp|heic|heif)$/i.test(f.name);
      if (self.files.length >= MAX_FILES) return self.error('You can add up to ' + MAX_FILES + ' photos or videos.');
      if (!video && !image) return self.error(f.name + " isn't a photo or video.");
      if (video && self.files.filter(function (x) { return x.video; }).length >= MAX_VIDEOS) return self.error('You can add up to ' + MAX_VIDEOS + ' videos.');
      if (video && f.size > MAX_VIDEO_MB * 1048576) return self.error('Videos need to be under ' + MAX_VIDEO_MB + 'MB. Try a shorter clip.');
      if (image && f.size > MAX_IMAGE_MB * 1048576) return self.error('Photos need to be under ' + MAX_IMAGE_MB + 'MB.');
      self.files.push({ file: f, video: video, preview: URL.createObjectURL(f) });
    });
    this.renderFiles();
  };

  Wall.prototype.renderFiles = function () {
    var self = this, box = this.q('[data-gr-files]'), add = box.querySelector('.gr-add');
    box.querySelectorAll('.gr-thumb').forEach(function (n) { n.remove(); });
    this.files.forEach(function (item, i) {
      var t = el('div', 'gr-thumb');
      var m = item.video ? el('video') : el('img');
      m.src = item.preview;
      if (item.video) { m.muted = true; m.playsInline = true; m.preload = 'metadata'; } else m.alt = '';
      t.appendChild(m);
      if (item.video) { var pl = el('span', 'gr-play'); pl.innerHTML = PLAY; t.appendChild(pl); }
      var x = el('button', 'gr-thumb__x', '×');
      x.type = 'button';
      x.setAttribute('aria-label', 'Remove');
      x.addEventListener('click', function () { URL.revokeObjectURL(item.preview); self.files.splice(i, 1); self.renderFiles(); });
      t.appendChild(x);
      box.insertBefore(t, add);
    });
    add.hidden = this.files.length >= MAX_FILES;
  };

  // Photos are re-drawn at max 1600px as JPEG: smaller uploads, and the phone's location data is dropped.
  function shrinkImage(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        var w = Math.round(img.naturalWidth * scale), h = Math.round(img.naturalHeight * scale);
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve({ blob: b, a: h / w }) : reject(new Error('Could not read photo')); }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error("We couldn't read one of your photos. Try a JPG or PNG.")); };
      img.src = url;
    });
  }
  // First frame of a video as a JPEG poster, plus its shape.
  function videoPoster(file) {
    return new Promise(function (resolve) {
      var v = document.createElement('video'), url = URL.createObjectURL(file), done = false;
      var finish = function (res) { if (done) return; done = true; URL.revokeObjectURL(url); resolve(res); };
      v.muted = true; v.playsInline = true; v.preload = 'auto';
      v.onloadedmetadata = function () { v.currentTime = Math.min(0.5, (v.duration || 1) / 2); };
      v.onseeked = function () {
        var scale = Math.min(1, 1000 / Math.max(v.videoWidth, v.videoHeight)) || 1;
        var c = document.createElement('canvas');
        c.width = Math.round(v.videoWidth * scale); c.height = Math.round(v.videoHeight * scale);
        try { c.getContext('2d').drawImage(v, 0, 0, c.width, c.height); } catch (e) { return finish({ a: v.videoHeight / v.videoWidth || 1.78 }); }
        c.toBlob(function (b) { finish({ blob: b, a: c.height / c.width }); }, 'image/jpeg', 0.82);
      };
      v.onerror = function () { finish({ a: 1.78 }); };
      setTimeout(function () { finish({ a: 1.78 }); }, 8000);
      v.src = url;
    });
  }

  Wall.prototype.progress = function (frac, label) {
    var p = this.q('[data-gr-progress]');
    p.hidden = frac == null;
    if (frac == null) return;
    p.querySelector('i').style.width = Math.round(frac * 100) + '%';
    p.querySelector('span').textContent = label || '';
  };

  Wall.prototype.submit = function () {
    var self = this, f = this.form;
    var val = function (n) { var x = f.elements[n]; return x ? String(x.value || '').trim() : ''; };
    var rating = (f.querySelector('input[name="rating"]:checked') || {}).value;
    this.error('');
    if (!rating) return this.error('Please choose a star rating.');
    if (val('body').length < 10) return this.error('Please write a little more about your experience.');
    if (!val('name')) return this.error('Please add your name.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) return this.error('Please check your email address.');

    var btn = this.q('[data-gr-submit]');
    btn.disabled = true;
    var api = this.api, handle = this.handle, media = [];
    var slug = function (name, ext) { return 'media/' + handle + '/' + Date.now().toString(36) + '-' + (name || 'file').toLowerCase().replace(/\.[^.]+$/, '').replace(/[^a-z0-9]+/g, '-').slice(0, 30) + ext; };
    var total = this.files.length, done = 0;

    var uploadAll = this.files.reduce(function (chain, item) {
      return chain.then(function (Blob) {
        var put = function (path, data, type) {
          return Blob.upload(path, data, {
            access: 'public', handleUploadUrl: api + '/api/upload', contentType: type,
            multipart: data.size > 8 * 1048576,
            onUploadProgress: function (ev) { self.progress((done + ev.percentage / 100) / total, 'Uploading ' + (done + 1) + ' of ' + total + '…'); },
          });
        };
        if (item.video) {
          var ext = (item.file.name.match(/\.(mp4|mov|webm|m4v)$/i) || ['.mp4'])[0].toLowerCase();
          return videoPoster(item.file).then(function (pv) {
            var posterUp = pv.blob ? put(slug(item.file.name + '-poster', '.jpg'), pv.blob, 'image/jpeg') : Promise.resolve(null);
            return posterUp.then(function (poster) {
              return put(slug(item.file.name, ext), item.file, item.file.type || 'video/mp4').then(function (up) {
                media.push({ url: up.url, kind: 'video', a: pv.a, poster: poster ? poster.url : '' });
                done++;
                return Blob;
              });
            });
          });
        }
        return shrinkImage(item.file).then(function (img) {
          return put(slug(item.file.name, '.jpg'), img.blob, 'image/jpeg').then(function (up) {
            media.push({ url: up.url, kind: 'image', a: img.a });
            done++;
            return Blob;
          });
        });
      });
    }, total ? this.loadUploader() : Promise.resolve(null));

    uploadAll.then(function () {
      self.progress(total ? 1 : null, 'Sending your review…');
      return fetch(api + '/api/reviews', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          handle: handle, rating: +rating, title: val('title'), body: val('body'), name: val('name'), email: val('email'),
          website: val('website'), elapsed: Date.now() - (self.openedAt || Date.now()), media: media, page: location.href,
        }),
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.error || 'Something went wrong.'); return j; }); });
    }).then(function () {
      self.progress(null);
      self.q('[data-gr-form-fields]').hidden = true;
      self.q('[data-gr-thanks]').hidden = false;
    }).catch(function (err) {
      self.progress(null);
      self.error((err && err.message) || "Your review didn't send. Please try again.");
    }).then(function () { btn.disabled = false; });
  };

  Wall.prototype.resetForm = function () {
    this.form.reset();
    this.files.forEach(function (x) { URL.revokeObjectURL(x.preview); });
    this.files = [];
    this.renderFiles();
    this.error('');
    this.q('[data-gr-form-fields]').hidden = false;
    this.q('[data-gr-thanks]').hidden = true;
  };

  function init() {
    document.querySelectorAll('[data-gr]').forEach(function (root) {
      if (!root.__gr) root.__gr = new Wall(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
